import { InputSearchFilter } from "@nosto/nosto-js/client"
import { useProductFilters as useBaseProductFilters } from "@nosto/search-js/preact/hooks"

/**
 * Preact hook that import product facets state to the component.
 *
 * **Should always be at the top of the component!**
 * @example
 * ```jsx
 * import { useProductFilters, useActions } from '@nosto/preact'
 *
 * export default () => {
 *     const { filters } = useProductFilters()
 *     const { toggleProductFilter } = useActions()
 *
 *     return filters.map((filter) => <li>
 *         <button
 *              title="Remove Filter"
 *              onClick={(e) => {
 *                  e.preventDefault()
 *                  toggleProductFilter(
 *                      filter.field,
 *                      filter.value,
 *                      false
 *                  )
 *              }}
 *          >
 *             {filter.filter}: {filter.value}{' '}
 *             <span>&#10005;</span>
 *          </button>
 *     </li>)
 * }
 * ```
 *
 * @group Hooks
 */
export function useProductFilters(): {
    /** Selected filters array. */
    filters: (
        | {
              value: string
              field: string
              name: string
              filter: {
                  range:
                      | {
                            gt: string | number | undefined
                            gte: string | number | undefined
                            lt: string | number | undefined
                            lte: string | number | undefined
                        }[]
                      | undefined
                  all?: InputSearchFilter[]
                  any?: InputSearchFilter[]
                  excludeFacets?: string[]
                  field?: string
                  hasValue?: boolean
                  not?: InputSearchFilter[]
                  prefix?: string[]
                  value?: string[]
              }
              remove: () => void
          }
        | undefined
    )[]
    /** Should remove all selected filters. */
    removeAll: () => void
} {
    return useBaseProductFilters()
}
